module.exports = __webpack_public_path__ + "static/media/comment-alt-plus.fb0149fd.svg";